var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBedroom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 32,
    viewBox: "0 0 34 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33 24V19.2M33 19.2H1M33 19.2H17V11.2H28.2C29.473 11.2 30.6939 11.7057 31.5941 12.6059C32.4943 13.5061 33 14.727 33 16V19.2ZM1 9.6V24M5.8 11.2C5.8 12.0487 6.13714 12.8626 6.73726 13.4627C7.33737 14.0629 8.15131 14.4 9 14.4C9.84869 14.4 10.6626 14.0629 11.2627 13.4627C11.8629 12.8626 12.2 12.0487 12.2 11.2C12.2 10.3513 11.8629 9.53737 11.2627 8.93726C10.6626 8.33714 9.84869 8 9 8C8.15131 8 7.33737 8.33714 6.73726 8.93726C6.13714 9.53737 5.8 10.3513 5.8 11.2Z",
    stroke: "var(--brand-color)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBedroom);
export default __webpack_public_path__ + "static/media/bedroom.ec6b0d6e0197a9a3d14a0881f81e5a87.svg";
export { ForwardRef as ReactComponent };